<template>
  <div class="coupon" :class="{'is-disabled': disabled}" @click="doclick($event)">
    <div class="coupon-item">
        <div class="price-wrapper">
            <div class="price-num">
              <span class="price-label">￥</span>
              <span class="number">{{ coupon.couponValue / 100 }}</span>
            </div>
            <div class="limit-desc">回收满{{ coupon.couponValueLimit/100 }}元可用</div>
        </div>
        <div class="coupon-desc">
            <div class="info">
              <div class="label">{{coupon.couponName}}</div>
              <div class="time">有效期至{{ coupon.validEndTime || coupon.couponValidEndTime }}</div>
            </div>
            <div class="icon">
              <slot name="icon"></slot>
            </div>
            <check-box class="checkbox" v-if="selectMode" :disabled="disabled" :true-label="coupon.couponId" v-model="selected"></check-box>
        </div>
    </div>
  </div>
</template>

<script>
import CheckBox from '@/components/checkbox';

export default {
  components: {
    CheckBox
  },
  props: {
    coupon: Object,
    disabled: Boolean,
    value: String,
    selectMode: Boolean
  },
  computed: {
    selected: {
      get () {
        return this.value;
      },
      set (v) {
        this.$emit('input', v);
      }
    }
  },
  methods: {
    doclick (ev) {
      if (this.disabled) {
        ev.stopPropagation();
        return;
      }
      if (!this.selectMode) {
        return;
      }
      if (this.selected && this.selected === this.coupon.couponId) {
        this.selected = '';
        return;
      }
      this.selected = this.coupon.couponId;
    }
  }
};
</script>

<style lang="css" scoped>
.is-disabled .coupon-item {
  background-image: url('./img/coupon_bg_set2@2x.png');
  .coupon-desc {
    .info {
      .label, .time {
        color: #949BA1;
      }
    }
  }
}

.checkbox {
  position: absolute;
  z-index: 10;
  top: 50%;
  right: 25px;
  transform: translateY(-50%);
  pointer-events: none;
}

/deep/ .hsb-checkbox .hsb-checkbox__inner {
  border-radius: 100%;
}

.is-disabled /deep/ .hsb-checkbox .hsb-checkbox__inner {
  border-color: #c9ced1;
}

/deep/ .hsb-checkbox.is-checked .hsb-checkbox__inner {
  background-color: #ff3405;
  border-color: #ff3405;
}

.coupon{
  position: relative;
  overflow: hidden;
}

.coupon-item {
  position: relative;
  width: 367px;
  height: 124px;
  margin: 0 auto;
  color: #fff;
  font-size: 12px;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: url('./img/coupon_bg_set1@2x.png') center center no-repeat;
  background-size: 100%;

  .price-wrapper {
    position: relative;
    width: 134px;
    height: 100%;
    color: #fff;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .price-num {
      .price-label {
        font-size: 20px;
      }
      .number {
       font-size: 36px;
      }
    }
    .limit-desc {
      font-size: 12px;
    }
  }
  .coupon-desc {
    position: relative;
    border-radius: 4px;
    padding-left: 18px;
    display: flex;
    width: 233px;
    box-sizing: border-box;
    justify-content: space-between;
    height: 100%;
    .info{
      height: 100%;
      .label{
        font-size: 14px;
        font-weight: bold;
        color: #2B2D2E;
        margin-top: 40px;
      }
      .time{
        margin-top: 12px;
        font-size: 12px;
        color: #646B70;
      }
      .unusedTxt{
        margin-top: 3px;
        font-size: 11px;
        color: #949BA1;
        img{
          width: 14px;
          height: 14px;
          vertical-align: middle;
        }
      }
    }
    .icon{
      img{
        width: 77px;
        height: 77px;
        vertical-align: top;
        margin-right: 12px;
        margin-top: 6px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/core/coupon/coupon.vue